import { MagnifyingGlassIcon, XCircleIcon } from "@heroicons/react/20/solid";
import React from "react";

interface SearchInputWithSelectOption<T extends string> {
    value: T;
    label: string;
}

interface SearchInputWithSelectProps<T extends string> {
    className: string;
    searchText: string;
    onSearchTextChange: (value: string) => void;
    searchPlaceholder: string;
    selectValue: T;
    onSelectChange: (value: T) => void;
    selectOptions: SearchInputWithSelectOption<T>[];
}

export function SearchInputWithSelect<T extends string>(
    props: SearchInputWithSelectProps<T>,
): JSX.Element {
    const {
        className,
        searchText,
        onSearchTextChange,
        searchPlaceholder,
        selectValue,
        onSelectChange,
        selectOptions,
    } = props;

    return (
        <div
            className={`flex items-center rounded-sm md:rounded border border-gray-300 hover:border-brand-600 focus-within:border-brand-400 focus-within:ring-2 focus-within:ring-brand-300 ${className}`}>
            <MagnifyingGlassIcon className="h-5 w-5 text-gray-400 ml-3 shrink-0" />
            <input
                className="block min-w-0 grow py-2 pl-2 pr-1 border-0 bg-transparent text-sm focus:ring-0 focus:outline-none"
                type="text"
                value={searchText}
                onChange={e => onSearchTextChange(e.target.value)}
                placeholder={searchPlaceholder}
            />
            {searchText ? (
                <XCircleIcon
                    className="h-5 w-5 text-gray-300 hover:text-gray-700 cursor-pointer shrink-0 mr-1"
                    onClick={() => onSearchTextChange("")}
                />
            ) : null}
            <select
                className="form-select shrink-0 self-stretch border-0 border-l border-gray-300 bg-transparent text-sm text-gray-600 rounded-r-sm md:rounded-r focus:ring-0 focus:outline-none"
                value={selectValue}
                onChange={e => onSelectChange(e.target.value as T)}>
                {selectOptions.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
}
